export enum FileTypeEnum {
  VIDEO = 'video',
  ZIP = 'zip',
  DOCUMENTS = 'documents',
  AUDIO = 'audio',
  IMAGE = 'image',
  VIRTUAL_CLASS = 'virtual class',
}
